/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PerformanceMetricResult,
  PerformanceMetricResult$inboundSchema,
  PerformanceMetricResult$Outbound,
  PerformanceMetricResult$outboundSchema,
} from "./performancemetricresult.js";

export type GetPerformanceMetricsResponse = {
  success?: true | undefined;
  data: Array<PerformanceMetricResult>;
};

/** @internal */
export const GetPerformanceMetricsResponse$inboundSchema: z.ZodType<
  GetPerformanceMetricsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  success: z.literal(true).default(true).optional(),
  data: z.array(PerformanceMetricResult$inboundSchema),
});

/** @internal */
export type GetPerformanceMetricsResponse$Outbound = {
  success: true;
  data: Array<PerformanceMetricResult$Outbound>;
};

/** @internal */
export const GetPerformanceMetricsResponse$outboundSchema: z.ZodType<
  GetPerformanceMetricsResponse$Outbound,
  z.ZodTypeDef,
  GetPerformanceMetricsResponse
> = z.object({
  success: z.literal(true).default(true as const),
  data: z.array(PerformanceMetricResult$outboundSchema),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetPerformanceMetricsResponse$ {
  /** @deprecated use `GetPerformanceMetricsResponse$inboundSchema` instead. */
  export const inboundSchema = GetPerformanceMetricsResponse$inboundSchema;
  /** @deprecated use `GetPerformanceMetricsResponse$outboundSchema` instead. */
  export const outboundSchema = GetPerformanceMetricsResponse$outboundSchema;
  /** @deprecated use `GetPerformanceMetricsResponse$Outbound` instead. */
  export type Outbound = GetPerformanceMetricsResponse$Outbound;
}

export function getPerformanceMetricsResponseToJSON(
  getPerformanceMetricsResponse: GetPerformanceMetricsResponse,
): string {
  return JSON.stringify(
    GetPerformanceMetricsResponse$outboundSchema.parse(
      getPerformanceMetricsResponse,
    ),
  );
}

export function getPerformanceMetricsResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetPerformanceMetricsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetPerformanceMetricsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetPerformanceMetricsResponse' from JSON`,
  );
}
